import { createClient } from '@supabase/supabase-js'
const supabase = createClient(
  import.meta.env.VITE_APP_SUPABASE_URL,
  import.meta.env.VITE_APP_SUPABASE_ANON_KEY
)
const auth = supabase.auth
const storage = supabase.storage

const BUCKET_PROFILE_IMAGE = 'profile'
export { auth, storage, BUCKET_PROFILE_IMAGE }
